module.exports = __webpack_public_path__ + "img/20191010171020514.00470f9a.jpg";